function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import memoize from 'lodash/memoize';
import { Cookie } from "./cookie";
import { goldlog } from "./goldlog";
import { cutDecimal } from "./numeral";
export var southEastCountries = ['SG', 'MY', 'TH', 'VN', 'ID', 'PH', 'PK',
// 巴基斯坦
'LK',
// 斯里兰卡
'MM',
// 缅甸
'BD',
// 孟加拉
'NP',
// 尼泊尔

'US',
// 美国

'FR',
// 法国
'ES',
// 西班牙
'DE',
// 德国
'IT',
// 意大利
'BE',
// 比利时

'GB',
// 英国
'NL',
// 荷兰
'PT',
// 葡萄牙
'FI',
// 芬兰
'DK',
// 丹麦
'NO',
// 挪威
'SE' // 瑞典
];

var window = globalThis;

// [ "ms_MY", "zh_TW", "en_US", "vi_VN", "zh_CN", "th_TH", "in_ID" ]
export var currencyLocaleMap = {
  SG: 'en',
  MY: 'ms',
  TH: 'th',
  VN: 'vi',
  ID: 'in',
  PH: 'en',
  US: 'en',
  // 美国

  FR: 'fr',
  // 法国
  ES: 'es',
  // 西班牙
  DE: 'de',
  // 德国
  IT: 'it',
  // 意大利
  BE: 'nl',
  // 比利时

  GB: 'en',
  // 英国
  NL: 'nl',
  // 荷兰
  PT: 'pt',
  // 葡萄牙
  FI: 'fi',
  // 芬兰
  DK: 'da',
  // 丹麦
  NO: 'no',
  // 挪威
  SE: 'sv',
  // 瑞典

  // 在当前业务中，主要以英语为主
  PK: 'en',
  // 巴基斯坦
  LK: 'en',
  // 斯里兰卡
  MM: 'en',
  // 缅甸
  BD: 'en',
  // 孟加拉
  NP: 'en' // 尼泊尔
};

export var southEastCurrencyMap = {
  SG: 'SGD',
  MY: 'MYR',
  TH: 'THB',
  VN: 'VND',
  ID: 'IDR',
  PH: 'PHP',
  US: 'USD',
  // 美国

  FR: 'EUR',
  // 法国
  ES: 'EUR',
  // 西班牙
  DE: 'EUR',
  // 德国
  IT: 'EUR',
  // 意大利
  BE: 'EUR',
  // 比利时

  GB: 'GBP',
  // 英国
  NL: 'EUR',
  // 荷兰
  PT: 'EUR',
  // 葡萄牙
  FI: 'EUR',
  // 芬兰
  DK: 'DKK',
  // 丹麦
  NO: 'NOK',
  // 挪威
  SE: 'SEK',
  // 瑞典

  PK: 'PKR',
  // 巴基斯坦
  LK: 'LKR',
  // 斯里兰卡
  MM: 'MMK',
  // 缅甸
  BD: 'BDT',
  // 孟加拉
  NP: 'NPR' // 尼泊尔
};

export var currencySymbolPositionMap = {
  SG: 'S${v}',
  MY: 'RM{v}',
  TH: '฿{v}',
  VN: '{v}₫',
  ID: 'Rp{v}',
  PH: '₱{v}',
  US: '${v}',
  // 美国

  FR: '{v}€',
  // 法国
  ES: '{v}€',
  // 西班牙
  DE: '{v}€',
  // 德国
  BE: '{v}€',
  // 比利时
  IT: '{v}€',
  // 意大利

  GB: '£{v}',
  // 英国
  NL: '{v}€',
  // 荷兰
  PT: '{v}€',
  // 葡萄牙
  FI: '{v}€',
  // 芬兰
  DK: 'kr{v}',
  // 丹麦
  NO: 'kr{v}',
  // 挪威
  SE: 'kr{v}',
  // 瑞典

  PK: 'Rs.{v}',
  // 巴基斯坦
  LK: 'Rs.{v}',
  // 斯里兰卡
  MM: 'Ks{v}',
  // 缅甸
  BD: '৳{v}',
  // 孟加拉
  NP: 'Rs.{v}' // 尼泊尔
};

export var southEastCurrencySymbolMap = mapValues(currencySymbolPositionMap, function (symbol) {
  return symbol.replace('{v}', '');
});
export var TZ = {
  SG: 'Asia/Singapore',
  TH: 'Asia/Bangkok',
  VN: 'Asia/Ho_Chi_Minh',
  ID: 'Asia/Jakarta',
  MY: 'Asia/Kuala_Lumpur',
  PH: 'Asia/Manila',
  US: 'America/New_York',
  // 美国

  FR: 'Europe/Paris',
  // 法国
  ES: 'Europe/Madrid',
  // 西班牙
  DE: 'Europe/Berlin',
  // 德国
  GB: 'Europe/London',
  // 英国
  IT: 'Europe/Rome',
  // 意大利
  BE: 'Europe/Brussels',
  // 比利时
  NL: 'Europe/Amsterdam',
  // 荷兰
  PT: 'Europe/Lisbon',
  // 葡萄牙
  DK: 'Europe/Copenhagen',
  // 丹麦
  NO: 'Europe/Oslo',
  // 挪威
  SE: 'Europe/Stockholm',
  // 瑞典
  FI: 'Europe/Helsinki',
  // 芬兰

  PK: 'Asia/Karachi',
  // 巴基斯坦
  BD: 'Asia/Dhaka',
  // 孟加拉国
  MM: 'Asia/Yangon',
  // 缅甸
  LK: 'Asia/Colombo',
  // 斯里兰卡
  NP: 'Asia/Kathmandu',
  // 尼泊尔

  CN: 'Asia/Shanghai' //中国
};

export function getTimeZone() {
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCountry();
  return TZ[country || 'SG'];
}
export function getCurrency() {
  var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCountry();
  return country && (symbol ? southEastCurrencySymbolMap : southEastCurrencyMap)[country];
}

/**
 * 缓存结果，document.querySelector 耗时一般在0.13ms+
 * 平凡使用情况下将会有性能问题
 */
export var getCountry = memoize(function () {
  if (void 0 === (window === null || window === void 0 ? void 0 : window.document)) {
    // Node 环境
    return '';
  }
  var country = function () {
    {
      var dom = document.querySelector('meta[name="env-country"]');
      if (dom !== null && dom !== void 0 && dom.content) {
        return dom.content;
      }
    }
    {
      var _dom = document.querySelector('meta[name="wt-country"]');
      if (_dom !== null && _dom !== void 0 && _dom.content) {
        return _dom.content;
      }
    }

    // CN 域名判断
    // eg. https://sellercenter-sg.lazada-seller.cn/
    var matches = window.location.host.match(/^sellercenter-(\w+)(-staging)?.lazada-seller.cn$/);
    if (matches !== null && matches !== void 0 && matches[1]) {
      return matches[1];
    }

    // ASC 域名判断
    // eg. sellercenter.lazada.sg
    var hostCountry = window.location.host.split('.');
    return hostCountry[hostCountry.length - 1];
  }();
  country = country.toUpperCase();
  if (southEastCountries.includes(country)) {
    return country;
  }
  return null;
});
export var getLang = memoize(function () {
  var _window$g_config, _document$querySelect, _document$querySelect2, _document$querySelect3;
  return Cookie.getCookie('_lang') ||
  // @ts-ignore
  window.__locale__ || ( // @ts-ignore
  window === null || window === void 0 ? void 0 : (_window$g_config = window.g_config) === null || _window$g_config === void 0 ? void 0 : _window$g_config.language) || ( // @ts-ignore
  (_document$querySelect = document.querySelector('meta[name="env-lang"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || ( // @ts-ignore
  (_document$querySelect2 = document.querySelector('meta[name="wt-lang"]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.content) || ((_document$querySelect3 = document.querySelector('html')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.getAttribute('lang')) || navigator.language;
});

/**
 * 获取美杜莎多语言Map，兼容ID等国规范不同的问题
 * @param localeMap
 * @param lang
 */
export function getMcmsLocale(localeMap) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLang();
  var dealWithLang = function dealWithLang(l) {
    l = l.toLowerCase().replace(/-/, '_');
    if (l === 'in_id') {
      l = 'id_id';
    } else if (l === 'es') {
      l = 'es_es';
    }
    return l;
  };
  lang = dealWithLang(lang);
  var newMap = mapKeys(localeMap, function (v, k) {
    return dealWithLang(k);
  });
  var locale = newMap[lang];
  if (/^en/.test(lang) && 'en_us' in newMap) {
    locale = Object.assign({}, newMap['en_us'], locale);
  }
  return locale;
}
export function getCountryLang() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCountry();
  var lang = getLang() || 'en_US';
  var country = (countryCode || '').toUpperCase();
  if (lang.toLowerCase() === 'en_us' && southEastCountries.includes(country)) {
    lang = "en_".concat(country);
  }
  return lang;
}

/**
 * Record pathname
 */
var currentPathname = '';
export function toLocaleString(value, options) {
  try {
    var _window$$$GlobalConfi;
    var _ref = options || {},
      countryCode = _ref.countryCode;
    try {
      var _location;
      if (currentPathname !== ((_location = location) === null || _location === void 0 ? void 0 : _location.pathname)) {
        var _location2, _window$goldlog, _window$goldlog$spm_a;
        currentPathname = (_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.pathname;
        goldlog({
          key: '/lzdseller.workstations-utils.local-number-format',
          data: _objectSpread(_objectSpread({
            pathname: currentPathname
          }, options), {}, {
            spm: "".concat((_window$goldlog = window.goldlog) === null || _window$goldlog === void 0 ? void 0 : (_window$goldlog$spm_a = _window$goldlog.spm_ab) === null || _window$goldlog$spm_a === void 0 ? void 0 : _window$goldlog$spm_a.join('.'), ".format_rules.tolocale_string")
          })
        });
      }
    } catch (e) {}
    if (!(window !== null && window !== void 0 && (_window$$$GlobalConfi = window['$$GlobalConfigration']) !== null && _window$$$GlobalConfi !== void 0 && _window$$$GlobalConfi.IDNumberFixedSwtich) && (countryCode === 'ID' || countryCode === 'VN')) {
      // ID\VN 考虑到存量卖家的心智习惯问题
      // 贸然修改格式化可能会导致卖家产生疑惑，所以暂时不处理 ID、VN 两国货币展示
      // PD: @Simon|许猛
      countryCode = 'SG';
    }
    return value.toLocaleString(currencyLocaleMap[countryCode], options);
  } catch (e) {
    return value.toLocaleString(undefined, options);
  }
}
export function getPrecisionNumber(number, precision, options) {
  if (typeof number !== 'number') {
    return '0';
  }
  var _ref2 = options || {},
    _ref2$countryCode = _ref2.countryCode,
    countryCode = _ref2$countryCode === void 0 ? getCountry() : _ref2$countryCode;
  if (precision === undefined) return toLocaleString(number, {
    countryCode: countryCode,
    maximumFractionDigits: 10
  });
  return toLocaleString(number, {
    countryCode: countryCode,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  });
}
export var DEFAULT_ABBREVIATION_LOCAL = {
  thousand: 'K',
  million: 'M',
  billion: 'B',
  trillion: 'T'
};
export function getAbbreviationsMap(langCode) {
  if (langCode === 'id_ID') {
    return {
      thousand: 'rb',
      million: 'jt',
      billion: 'M',
      trillion: 'T'
    };
  }

  // unicode.org/cldr/cldr-aux/charts/28/verify/numbers/en.html
  return DEFAULT_ABBREVIATION_LOCAL;
}
export function getAbbreviations(number, options) {
  var _ref3 = options || {},
    _ref3$precision = _ref3.precision,
    precision = _ref3$precision === void 0 ? 2 : _ref3$precision,
    langCode = _ref3.langCode,
    _ref3$locale = _ref3.locale,
    locale = _ref3$locale === void 0 ? {} : _ref3$locale,
    countryCode = _ref3.countryCode;
  var unitMap = Object.assign(getAbbreviationsMap(langCode), locale);
  var unitArr = Object.keys(unitMap);
  var unitIndex = 0;
  var target = number;
  while (target > 1000) {
    target = number / 1000;
    if (unitArr[unitIndex]) {
      number = target;
      unitIndex++;
    } else {
      break;
    }
  }
  var unit = unitMap[unitArr[unitIndex - 1]] || '';
  return getPrecisionNumber(cutDecimal(number, precision), undefined, {
    countryCode: countryCode
  }) + unit;
}

/**
 * 获取当前业务身份
 * @returns LAZADA | DARAZ
 */
export var getBU = memoize(function () {
  if (void 0 === (window === null || window === void 0 ? void 0 : window.document)) {
    // Node 环境
    return '';
  }
  var dom = document.querySelector('meta[name="env-bu"]');
  return dom === null || dom === void 0 ? void 0 : dom.content;
});
export var ASCTools = {
  getBU: getBU,
  getCountry: getCountry,
  getLang: getLang,
  getCountryLang: getCountryLang,
  getCurrency: getCurrency,
  getTimeZone: getTimeZone,
  southEastCurrencyMap: southEastCurrencyMap,
  southEastCurrencySymbolMap: southEastCurrencySymbolMap,
  southEastCountries: southEastCountries,
  getMcmsLocale: getMcmsLocale,
  getPrecisionNumber: getPrecisionNumber,
  getAbbreviations: getAbbreviations
};